import {
    cartList
} from '@/api/cart'
import {
    addressList
} from "@/api/user";
import {
    getOrderCount
} from '@/api/user'
import {
    address
} from '@/api/user'
import store from '@/utils/store';

const actions = {
    // 获取购物车
    cartList(context, isReLoad = false) {
        store.loadCacheData(context, 'cartList', cartList, null, {
            isReLoad: isReLoad,
            mutationName: 'cartList'
        });
    },
    // 获取地址列表
    addressList(context, isReLoad = false) {
        store.loadCacheData(context, 'addressList', addressList, null, {
            isReLoad: isReLoad
        });
    },
    // 获取默认收货地址
    address(context, isReLoad = false) {
        store.loadCacheData(context, 'address', address, null, {
            isReLoad: isReLoad
        });
    },
    // 获取用户订单数量
    orderCount(context, isReLoad = false) {
        store.loadCacheData(context, 'orderCount', getOrderCount, null, {
            isReLoad: isReLoad
        });
    }
}
export default actions